import type { SVGProps } from 'react';

/**
 * OceanneLogo — leaf sprig sage validé par Océanne (Phase 27.83).
 * Vectoriel propre, themable via `currentColor` (s'adapte au contexte parent).
 * Source SVG : Gemini-generated, validé visuellement 2026-06-01.
 *
 * Default color = brand secondary sage (`--secondary` ≈ #95A17B).
 * Override via className `text-foreground`, `text-primary`, etc.
 */
export function OceanneLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      fill="none"
      stroke="currentColor"
      strokeWidth="4.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <g transform="rotate(180 100 100)">
        <line x1="100" y1="50" x2="100" y2="150" />
        <path d="M 100,105 C 60,90 70,45 100,55" />
        <path d="M 100,55 C 140,45 140,105 100,95" />
      </g>
    </svg>
  );
}
